<template>
  <div>
    <v-chip
      v-if="!loading"
      :color="chipColor"
      :text-color="chipTextColor"
      label
      small
    >
      {{ value }}
    </v-chip>
    <v-progress-circular
      v-else
      :size="20"
      :width="3"
      indeterminate
      color="primary"
    />
  </div>
</template>

<script>
export default {
  name: 'StockChip',

  props: {
    value: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: () => ({
    chipColor: 'error',
    chipTextColor: 'white'
  }),

  watch: {
    value: {
      immediate: true,
      handler () {
        this.chipColor = this.getChipColor(this.value)
      }
    }
  },

  methods: {
    getChipColor (value) {
      if (value > 10) return 'success'
      if (value > 0 && value <= 10) return 'primary'
      if (value <= 0) return 'error'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chips/StockChip.vue